import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
	componentDidUpdate(prevProps) {
		if(this.props.location.pathname !== prevProps.location.pathname) {
			if (window._czc) {
				let location = window.location
				let contentUrl = location.pathname + location.hash
				let refererUrl = '/'
				window._czc.push(['_trackPageview', contentUrl, refererUrl])
			}
		}
	}
	render() {
		return this.props.children
	}
}

export default withRouter(ScrollToTop);















